/**
 * Created by nijin on 21/4/17.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attrNameFilter',
  pure: false
})
export class AttributeNameFilter implements PipeTransform {
  transform(items: any[], filter: any): any {
    filter.name.trim();
    if (!items || !filter || !filter.name || !filter.name.length) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    let result =  items.filter(item => item.name.toLocaleLowerCase().includes(filter.name.toLowerCase()));
    return result.length ? result : [-1];
  }
}



// WEBPACK FOOTER //
// ./src/app/things/things-details/event-visual/attributeNameFilter.ts